export const loyaltyProgramNames = {
  ihg: 'IHG Rewards Club',
  radisson: 'Radisson Rewards',
  choice: 'Choice Privileges',
  hyatt: 'World of Hyatt',
  wyndham: 'Wyndham Rewards',
  marriott: 'Marriott Bonvoy',
  bestwestern: 'Best Western Rewards',
  hilton: 'Hilton Honors',
  sonesta: 'Sonesta Travel Pass'
}

export const loyaltyProgramLevelsList = {
  ihg: ['CLUB', 'GOLD', 'PLATINUM', 'SPIRE', 'DIAMOND', 'SILVER'],
  radisson: ['CLUB', 'SILVER', 'PLATINUM', 'GOLD'],
  choice: ['Elite Gold', 'Elite Platinum', 'Elite Diamond'],
  hyatt: ['MEMB', 'DISV', 'EXPL', 'GLOB', 'LGLO'],
  wyndham: ['BLUE', 'GOLD', 'PLATINUM', 'DIAMOND', 'TITATIUM'],
  marriott: [
    'Member',
    'Silver Elite',
    'Gold Elite',
    'Platinum Elite',
    'Titanium Elite',
    'Ambassador Elite'
  ],
  bestwestern: ['BASE', 'BLUE', 'GOLD', 'Platinum', 'DIAMOND', 'DIAMOND SELECT'],
  hilton: ['Member', 'Silver', 'Gold', 'Diamond'],
  sonesta: ['SILVER', 'BRONZE', 'GOLD', 'PLATINUM', 'TRAVELPASS']
}

export const loyaltyProgramLevelNames = {
  ihg: {
    CLUB: 'Club',
    GOLD: 'Gold',
    PLATINUM: 'Platinum',
    SPIRE: 'Spire',
    DIAMOND: 'Diamond',
    SILVER: 'Silver'
  },
  radisson: {
    CLUB: 'Club',
    SILVER: 'Silver',
    PLATINUM: 'Platinum',
    GOLD: 'Gold'
  },
  choice: {
    'Elite Gold': 'Gold',
    'Elite Platinum': 'Platinum',
    'Elite Diamond': 'Diamond'
  },
  hyatt: {
    MEMB: 'Member',
    DISV: 'Discoverist',
    EXPL: 'Explorist',
    GLOB: 'Globalist',
    LGLO: 'Lifetime Globalist'
  },
  wyndham: {
    BLUE: 'Blue',
    GOLD: 'Gold',
    PLATINUM: 'Platinum',
    DIAMOND: 'Diamond',
    TITATIUM: 'Titanium'
  },
  marriott: {
    Member: 'Member',
    'Silver Elite': 'Silver Elite',
    'Gold Elite': 'Gold Elite',
    'Platinum Elite': 'Platinum Elite',
    'Titanium Elite': 'Titanium Elite',
    'Ambassador Elite': 'Ambassador Elite'
  },
  bestwestern: {
    BASE: 'Base',
    BLUE: 'Blue',
    GOLD: 'Gold',
    Platinum: 'Platinum',
    DIAMOND: 'Diamond',
    'DIAMOND SELECT': 'Diamond Select'
  },
  hilton: {
    Member: 'Member',
    Silver: 'Silver',
    Gold: 'Gold',
    Diamond: 'Diamond'
  },
  sonesta: {
    TRAVELPASS: 'Member',
    SILVER: 'Silver',
    BRONZE: 'Bronze',
    GOLD: 'Gold',
    PLATINUM: 'Platinum'
  }
}

export const loyaltyProgramLevels = {
  ihg: {
    CLUB: 'CLUB',
    GOLD: 'GOLD',
    PLATINUM: 'PLATINUM',
    SPIRE: 'SPIRE',
    DIAMOND: 'DIAMOND',
    SILVER: 'SILVER'
  },
  radisson: {
    CLUB: 'CLUB',
    SILVER: 'SILVER',
    PLATINUM: 'PLATINUM',
    GOLD: 'GOLD'
  },
  choice: {
    'Elite Gold': 'Elite Gold',
    'Elite Platinum': 'Elite Platinum',
    'Elite Diamond': 'Elite Diamond'
  },
  hyatt: {
    MEMB: 'MEMB',
    DISV: 'DISV',
    EXPL: 'EXPL',
    GLOB: 'GLOB',
    LGLO: 'LGLO'
  },
  wyndham: {
    BLUE: 'BLUE',
    GOLD: 'GOLD',
    PLATINUM: 'PLATINUM',
    DIAMOND: 'DIAMOND',
    TITATIUM: 'TITATIUM'
  },
  marriott: {
    Member: 'Member',
    'Silver Elite': 'Silver Elite',
    'Gold Elite': 'Gold Elite',
    'Platinum Elite': 'Platinum Elite',
    'Titanium Elite': 'Titanium Elite',
    'Ambassador Elite': 'Ambassador Elite'
  },
  bestwestern: {
    BASE: 'BASE',
    BLUE: 'BLUE',
    GOLD: 'GOLD',
    SILVER: 'SILVER',
    Platinum: 'Platinum',
    DIAMOND: 'DIAMOND',
    'DIAMOND SELECT': 'DIAMOND SELECT'
  },
  hilton: {
    Member: 'Member',
    Silver: 'Silver',
    Gold: 'Gold',
    Diamond: 'Diamond'
  },
  sonesta: {
    TRAVELPASS: 'TRAVELPASS',
    SILVER: 'SILVER',
    BRONZE: 'BRONZE',
    GOLD: 'GOLD',
    PLATINUM: 'PLATINUM'
  }
}

export const loyaltyProgramLevelsNew = {
  ihg: {
    CLUB: {
      name: 'Club',
      code: 'CLUB'
    },
    GOLD: {
      name: 'Gold',
      code: 'GOLD'
    },
    PLATINUM: {
      name: 'Platinum',
      code: 'PLATINUM'
    },
    SPIRE: {
      name: 'Spire',
      code: 'SPIRE'
    },
    DIAMOND: {
      name: 'Diamond',
      code: 'DIAMOND'
    },
    SILVER: {
      name: 'Silver',
      code: 'SILVER'
    }
  },
  radisson: {
    CLUB: {
      name: 'Club',
      code: 'CLUB'
    },
    SILVER: {
      name: 'Silver',
      code: 'SILVER'
    },
    PLATINUM: {
      name: 'Platinum',
      code: 'PLATINUM'
    },
    GOLD: {
      name: 'Gold',
      code: 'GOLD'
    }
  },
  choice: {
    'Elite Gold': {
      name: 'Gold',
      code: 'Elite Gold'
    },
    'Elite Platinum': {
      name: 'Platinum',
      code: 'Elite Platinum'
    },
    'Elite Diamond': {
      name: 'Diamond',
      code: 'Elite Diamond'
    }
  },
  hyatt: {
    MEMB: {
      name: 'Member',
      code: 'MEMB'
    },
    DISV: {
      name: 'Discoverist',
      code: 'DISV'
    },
    EXPL: {
      name: 'Explorist',
      code: 'EXPL'
    },
    GLOB: {
      name: 'Globalist',
      code: 'GLOB'
    },
    LGLO: {
      name: 'Lifetime Globalist',
      code: 'LGLO'
    }
  },
  wyndham: {
    BLUE: {
      name: 'Blue',
      code: 'BLUE'
    },
    GOLD: {
      name: 'Gold',
      code: 'GOLD'
    },
    PLATINUM: {
      name: 'Platinum',
      code: 'PLATINUM'
    },
    DIAMOND: {
      name: 'Diamond',
      code: 'DIAMOND'
    },
    TITATIUM: {
      name: 'Titanium',
      code: 'TITATIUM'
    }
  },
  marriott: {
    Member: {
      name: 'Member',
      code: 'Member'
    },
    'Silver Elite': {
      name: 'Silver Elite',
      code: 'Silver Elite'
    },
    'Gold Elite': {
      name: 'Gold Elite',
      code: 'Gold Elite'
    },
    'Platinum Elite': {
      name: 'Platinum Elite',
      code: 'Platinum Elite'
    },
    'Titanium Elite': {
      name: 'Titanium Elite',
      code: 'Titanium Elite'
    },
    'Ambassador Elite': {
      name: 'Ambassador Elite',
      code: 'Ambassador Elite'
    }
  },
  bestwestern: {
    BASE: {
      name: 'Base',
      code: 'BASE'
    },
    BLUE: {
      name: 'Blue',
      code: 'BLUE'
    },
    GOLD: {
      name: 'Gold',
      code: 'GOLD'
    },
    Platinum: {
      name: 'Platinum',
      code: 'Platinum'
    },
    DIAMOND: {
      name: 'Diamond',
      code: 'DIAMOND'
    },
    'DIAMOND SELECT': {
      name: 'Diamond Select',
      code: 'DIAMOND SELECT'
    }
  },
  hilton: {
    Member: {
      name: 'Member',
      code: 'Member'
    },
    Silver: {
      name: 'Silver',
      code: 'Silver'
    },
    Gold: {
      name: 'Gold',
      code: 'Gold'
    },
    Diamond: {
      name: 'Diamond',
      code: 'Diamond'
    }
  },
  sonesta: {
    TRAVELPASS: {
      name: 'Member',
      code: 'TRAVELPASS'
    },
    SILVER: {
      name: 'Silver',
      code: 'SILVER'
    },
    BRONZE: {
      name: 'Bronze',
      code: 'BRONZE'
    },
    GOLD: {
      name: 'Gold',
      code: 'GOLD'
    },
    PLATINUM: {
      name: 'Platinum',
      code: 'PLATINUM'
    }
  }
}
